// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"c536c871","35":"c536c871","211":"c536c871","465":"a415f2a0","555":"f06d6d69","560":"c536c871","628":"c536c871","768":"c536c871","805":"c536c871","995":"a25a43be"}[chunkId] + ".chunk.css";
};